import React, { useState } from "react";
import { BiX } from "react-icons/bi";
import { FiMenu } from "react-icons/fi";
import logo from "../../../asset/Logo/logo.png";
const Navbar = ({ children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div
      data-aos="fade-down"
      data-aos-duration="1000"
      data-theme="dark"
      className="lg:w-10/12 w-11/12 mx-auto "
    >
      <div className="navbar justify-between bg-base-100 py-5">
        <div className="navbar-start">
          {/* <a className=" btn btn-ghost text-primary normal-case text-xl">
            
          </a> */}
          <img src={logo} className="w-12 " alt="it's Me" />
        </div>
        <div className="navbar-center  xl:w-5/12  hidden lg:flex">
          <ul className="menu menu-horizontal px-1">
            <li>
              <a href="#about">
                {" "}
                <span className="text-primary">01.</span> About
              </a>
            </li>
            <li>
              <a href="#experience">
                <span className="text-primary">02.</span> Experience
              </a>
            </li>
            <li>
              <a href="#project">
                <span className="text-primary">03.</span> Work
              </a>
            </li>
            <li>
              <a href="#contact">
                <span className="text-primary">04.</span> Contact
              </a>
            </li>
          </ul>
        </div>
        <div className="w-full lg:hidden lg:flex justify-end navbar-end">
          <div className="dropdown lg:hidden">
            <label
              htmlFor="my-drawer"
              onClick={() => setOpen(!open)}
              className="btn btn-square btn-ghost transition-all ease-in duration-700  "
            >
              {open ? (
                <BiX className="text-4xl " />
              ) : (
                <FiMenu className="text-2xl" />
              )}
            </label>
          </div>
        </div>
      </div>
      <div className="">
        <div className="">
          <ul
            className={` px-7 py-10 z-10 transition-all ease-in duration-500 lg:hidden block bg-neutral ${
              open ? "top-20" : "-top-72"
            } font-mono text-center absolute  w-full`}
          >
            <li className="my-4">
              <a href="#about">
                {" "}
                <span className="text-primary">01.</span> About
              </a>
            </li>
            <li className="my-4">
              <a href="#experience">
                <span className="text-primary">02.</span> Experience
              </a>
            </li>
            <li className="my-4">
              <a href="#project">
                <span className="text-primary">03.</span> Work
              </a>
            </li>
            <li className="my-4">
              <a href="#contact">
                <span className="text-primary">04.</span> Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
      {children}
    </div>
  );
};

export default Navbar;
